import React from 'react';
import ForecastStartingComponent from './ForecastStartingComponent';
const ForecastStartForm = ({ formikProps }) => {
    return React.createElement(ForecastStartingComponent, { formikProps: formikProps });
};
export default ForecastStartForm;
